// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1h60p","content":"styles_content__3F1iV","checkbox":"styles_checkbox__2oVB6","checkboxLabel":"styles_checkboxLabel__3cc70"};